module.exports = __webpack_public_path__ + "img/nav-toggle.883d470c.svg";